import React, {useContext} from "react";
import {GlobalDataContext} from "../../../contexts/GlobalDataContext";
import {RegionSelectedContext, regionValues} from "../../../contexts/RegionSelectedContext";
import PillRow, {HeaderPillRow, PillRecord} from "../../pills/PillRow";
import EuropeRecord from "../../../models/EuropeRecord";
import Branch from "../../../interfaces/Branch";
import LatamRecord from "../../../models/LatamRecord";
import styled from "styled-components";

const PillsTable = styled.div`
  display: flex;

  @media (max-height: 900px) {
    font-size: 0.8rem;
  }
`;

const parseEuropeRecords = (records: EuropeRecord[], year: number): PillRecord[] => {
    return records
        .filter((record: EuropeRecord) => record.year === year)
        .filter((record: EuropeRecord) => record.branch === Branch.TOTAL)
        .sort((r1: EuropeRecord, r2: EuropeRecord) => r2.premiums_current_year - r1.premiums_current_year)
        .slice(0, 15)
        .map((x: EuropeRecord) => {
            return {
                company_group: x.company_group,
                premiums: x.premiums_current_year,
                registered_office: x.registered_office
            };
        });
};

const parseLatamRecords = (records: LatamRecord[], year: number): PillRecord[] => {
    return records
        .filter((record: LatamRecord) => record.year === year)
        .filter((record: LatamRecord) => record.branch === Branch.TOTAL)
        .sort((r1: LatamRecord, r2: LatamRecord) => r2.premiums - r1.premiums)
        .slice(0, 15)
        .map((x: LatamRecord) => {
            return {
                company_group: x.company_group,
                premiums: x.premiums,
                registered_office: x.registered_office
            };
        });
};


const TotalRankingPillsComponent: React.FC = () => {
    // @ts-ignore
    const {europeRecords, latamRecords} = useContext(GlobalDataContext);
    // @ts-ignore
    const { yearSelected, regionSelected } = useContext(RegionSelectedContext);

    if (Object.keys(europeRecords).length === 0) {
        return (<div/>);
    }

    const currency = regionSelected == 'eu' ? 'M€' : 'M USD';

    const records: PillRecord[] =
        regionSelected === regionValues.europe
            ? parseEuropeRecords(europeRecords, yearSelected)
            : parseLatamRecords(latamRecords, yearSelected);

    return (
        <PillsTable>
            <div style={{flex: 5, display: "flex", flexDirection: "column"}}>
                <HeaderPillRow
                    year={ yearSelected }
                    isDark={false}
                    currency={ currency }
                />
                {records.map((record, i) => {
                    return (
                        <PillRow
                            number={i + 1}
                            record={record}
                            isDark={false}
                            key={record.company_group}
                        />
                    );
                })}
            </div>
        </PillsTable>
    );
};

export default TotalRankingPillsComponent
